{
	"title": "Serviciu indisponibil (500)",
	"description": "Încercați să reîmprospătați această pagină sau verificați conexiunea la internet. Dacă această eroare persistă, vă rugăm să o raportați ca bug, astfel încât să putem lua măsuri.",
	"primaryButtonTitle": "Reîmprospătează pagina",
	"secondaryButtonTitle": "Copiază jurnalul de erori",
	"errorLogCopiedMessage": "Jurnalul de erori a fost copiat",
	"traceparentLabel": "Traceparent"
}
